/**
 * UrgencyBadge — countdown badge showing task urgency.
 *
 * COORD-26: Color-coded urgency labels for the accountability quadrant. Theme-aware.
 */
export default function UrgencyBadge({ daysRemaining }) {
  let label, classes;

  if (daysRemaining < 0) {
    label = "OVERDUE";
    classes = "bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400";
  } else if (daysRemaining === 0) {
    label = "TODAY";
    classes = "bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400";
  } else if (daysRemaining === 1) {
    label = "TOMORROW";
    classes = "bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400";
  } else {
    label = `${daysRemaining}d`;
    classes = "bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-slate-300";
  }

  return (
    <div
      className={`flex items-center justify-center rounded text-[9px] font-bold uppercase tracking-wide flex-shrink-0 ${classes}`}
      style={{ width: 52, height: 28 }}
    >
      {label}
    </div>
  );
}
